export interface Config {
  selector: string;
  straightOnly?: boolean;
  rememberSource?: boolean;
  disabled?: boolean;
  defaultElement?: string;
  enterTo?: EnterToOptions;
  leaveFor?: null | PlainObject;
  restrict?: RestrictOptions;
  tabIndexIgnoreList?: string;
  navigableFilter?: null | navigableFilter;
}
type Primitive = bigint | boolean | null | number | string | symbol | undefined;

type PlainObject = Record<string, Primitive>;

export const enum EnterToOptions {
  Empty = "",
  LastFocused = "last-focused",
  DefaultElement = "default-element"
}

export const enum RestrictOptions {
  SelfFirst = "self-first",
  SelfOnly = "self-only",
  None = "none"
}

export interface navigableFilter {
  (elem: HTMLElement): boolean;
}

export interface SpatialNavigationEvent {
  bubbles: boolean;
  cancelable: boolean;
  sectionId: string;
  previousElement: HTMLElement;
  direction: "left" | "right" | "up" | "down";
  native: boolean;
}
